export const APP_DATA_REFRESH_EVENT = 'timelining:data-refresh-request'

export type AppDataRefreshDetail = {
  reason: string
  requestedAt: number
}

export const requestAppDataRefresh = (reason: string): void => {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent<AppDataRefreshDetail>(APP_DATA_REFRESH_EVENT, {
    detail: { reason, requestedAt: Date.now() },
  }))
}
